import { Controller } from "@hotwired/stimulus";
import * as L from 'leaflet';
import 'leaflet.markercluster';
import { GestureHandling } from "leaflet-gesture-handling";
import * as Turbo from "@hotwired/turbo";

import "./WorldMap.scss";

interface MapMarker {
    UniqueId: string;
    Language: string;
    Name: string;
    ImageUrl: string;
    Url: string;
    Latitude: number;
    Longitude: number;
}

export default class WorldMapController extends Controller {
    static targets = [];
    static values = {
        markers: String,
        detailLinkTemplate: String
    }
    markersValue!: string;
    detailLinkTemplateValue!: string;

    connect() {
        const markers = JSON.parse(decodeURIComponent(this.markersValue)) as MapMarker[];

        L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);
        const map = L.map(this.element as HTMLElement, { fullscreenControl: true });
        map.setView([0, 0], 1);
        // @ts-ignore
        map.gestureHandling.enable();

        L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}',
            {
                maxZoom: 22,
                id: "mapbox/outdoors-v11",
                accessToken: "pk.eyJ1Ijoic21hcnQtZ3VpZGUiLCJhIjoiY2s0c2dyaWR4MDA0eDNrbW00czFwczc4cyJ9.2FnIFSxmPsJkD-o5NLOUPA",
                tileSize: 512,
                zoomOffset: -1
            }).addTo(map);

        L.Icon.Default.imagePath = "/lib/leaflet/images/";

        const mapMarkers = markers
            .map(m => {
                const destinationDetailUrl = this.detailLinkTemplateValue.replace('$UniqueId$', m.UniqueId).replace('$Language$', m.Language);

                const icon = L.divIcon({
                    className: 'x',
                    iconSize: [40, 40],
                    html: `<img width="40" height="40" class="round-marker" crossorigin="anonymous" src="${m.ImageUrl}" />`
                });

                return L.marker(
                        L.latLng(m.Latitude, m.Longitude),
                        {
                            icon,
                            title: m.Name
                        }
                    )
                    .on('click', () => {
                        Turbo.visit(destinationDetailUrl);
                    });
            });

        const cluster = L.markerClusterGroup();
        cluster.addLayers(mapMarkers);
        cluster.addTo(map);

        map.fitBounds(cluster.getBounds());

        $(this.element).find('img.leaflet-marker-icon').attr('crossorigin', 'anonymous');
    }
}
